import { NotificationViewModel } from '@/presentation/viewmodels/notification/notificationViewModel'
import { store } from '@/store'

export class NotificationPresenter {
  private viewModel: NotificationViewModel

  constructor(viewModel: NotificationViewModel = new NotificationViewModel(store)) {
    this.viewModel = viewModel
  }

  welcomeNotification() {
    this.viewModel.welcome()
  }

  loginNotification(userId: string) {
    this.viewModel.login(userId)
  }

  logoutNotification() {
    this.viewModel.logout()
  }

  errorNotification(error: string) {
    this.viewModel.error(error)
  }

  registerReviewNotification() {
    this.viewModel.registerReview()
  }

  invalidReviewNotification() {
    this.viewModel.invalidReview()
  }

  registerReviewErrorNotification() {
    this.viewModel.registerReviewError()
  }

  evaluateNotification(score: number) {
    this.viewModel.evaluate(score)
  }

  closeEntryNotification() {
    this.viewModel.closeEntry()
  }

  submitReviewNotification() {
    this.viewModel.submitReview()
  }

  copyNotification() {
    this.viewModel.copy()
  }

  acNotification(type: 'Run' | 'Judge', problemId: string, judgeId: string) {
    this.viewModel.ac({ type, problemId, judgeId })
  }

  wrongNotification(status: string, type: 'Run' | 'Judge', problemId: string, judgeId: string) {
    this.viewModel.wrong({ status, type, problemId, judgeId })
  }

  freeSpaceResultNotification(showFreeSpaceModal: boolean, problemId: string) {
    this.viewModel.freeSpaceResult({ showFreeSpaceModal, problemId })
  }

  openRunningNotification(type: 'Run' | 'Judge', showFreeSpaceModal: boolean, problemId: string) {
    this.viewModel.openRunning({ type, showFreeSpaceModal, problemId })
  }

  noLoginNotification() {
    this.viewModel.noLogin()
  }

  recommendEntryNotification() {
    this.viewModel.recommendEntry()
  }

  closeRunningNotification() {
    this.viewModel.closeRunning()
  }
}
